import React from 'react';

import StandAloneProductComparison from '../ProductSearch/ProductComparison/StandAloneProductComparison';

const ProductComparison = () => (<StandAloneProductComparison />);

export default ProductComparison;
